<template>
    <FormSection>
        <template #title>
            Voucher Information
        </template>

        <template #description>
            Relevant data and other details
        </template>

        <template #form>
           
            <div class="col-span-6">
                <TextInput 
                    id="voucher_name"
                    name="voucher_name"
                    label="Voucher Name"
                    placeholder="Voucher Name"
                    v-model="form.name"
                    :error="errors.name ? errors.name[0] : ''"
                />
            </div>

            <div class="col-span-6">
                <TextInput 
                    id="voucher_code"
                    name="voucher_code"
                    label="Voucher Code"
                    placeholder="Voucher Code"
                    v-model="form.code"
                    :error="errors.code ? errors.code[0] : ''"
                    customClass="uppercase"
                />
            </div>
           
            <div class="col-span-12">
                <radio-group
                    label="Participating Packages"
                    :options="packageOptions"
                    name="packages"
                    keyID="packages"
                    v-model="form.package_type"
                    :error="errors.package_type ? errors.package_type[0] : ''"
                />
                <MultiselectInput
                    v-if="form.package_type === PackageType.SPECIFIC"
                    name="participating_package"
                    placeholder="Participating Packages"
                    :options="packages"
                    searchable
                    mode="tags"
                    v-model="form.package_ids"
                    :error="errors.package_ids ? errors.package_ids[0] : ''"
                />
            </div>
            <div class="col-span-12">
                <radio-group
                    label="Participating Riders"
                    :options="riderOptions"
                    name="riders"
                    keyID="riders"
                    v-model="form.rider_type"
                    :error="errors.rider_type ? errors.rider_type[0] : ''"
                />
                <MultiselectInput
                    v-if="form.rider_type === RiderType.SPECIFIC"
                    name="participating_riders"
                    placeholder="Participating Riders"
                    :options="riderFormattedOptions"
                    searchable
                    mode="tags"
                    v-model="form.rider_ids"
                    :error="errors.rider_ids ? errors.rider_ids[0] : ''"
                />
            </div>

            <div class="col-span-12">
                <radio-group
                    label="Participating Patients"
                    :options="patientOptions"
                    name="customers"
                    keyID="customers"
                    v-model="form.patient_type"
                    :error="errors.patient_type ? errors.patient_type[0] : ''"
                />
                <MultiselectInput
                    v-if="form.patient_type === PatientType.SPECIFIC"
                    name="participating_customer"
                    placeholder="Participating Customer"
                    :options="patients"
                    searchable
                    mode="tags"
                    v-model="form.patient_ids"
                    :error="errors.patient_ids ? errors.patient_ids[0] : ''"
                />
                <!-- <MultiselectInput
                    v-if="participatingCustomer === 'Individual Patients'"
                    name="participating_customer"
                    placeholder="Participating Customer"
                    :options="[
                        { id: '1', label: 'Sample1', value: 'Sample1'},
                        { id: '2', label: 'Sample2', value: 'Sample2'},
                        { id: '3', label: 'Sample3', value: 'Sample3'},
                    ]"
                    searchable
                    mode="tags"
                />
                <MultiselectInput
                    v-else-if="participatingCustomer === 'Corporate Patients'"
                    name="participating_companies"
                    placeholder="Participating Companies"
                    :options="[
                        { id: '1', label: 'Sample1', value: 'Sample1'},
                        { id: '2', label: 'Sample2', value: 'Sample2'},
                        { id: '3', label: 'Sample3', value: 'Sample3'},
                    ]"
                    searchable
                    mode="tags"
                /> -->
            </div>

            <div class="col-span-12">
                <radio-group
                    label="How many times can this be used?"
                    :options="maxUsageOptions"
                    name="timesUsed"
                    keyID="timesUsed"
                    v-model="form.max_usage_type"
                    :error="errors.max_usage_type ? errors.max_usage_type[0] : ''"
                />
                <TextInput 
                    v-if="form.max_usage_type === MaxUsageType.LIMITED"
                    id="max_usage"
                    name="max_usage"
                    type="number"
                    :min="1"
                    placeholder="Max Order Count"
                    v-model="form.max_usage_count"
                    :error="errors.max_usage_count ? errors.max_usage_count[0] : ''"
                    @update:modelValue="(value) => (form.max_usage_count = value)"
                />
            </div>
            <!-- <div class="col-span-12">
                <radio-group
                    v-model="minimumCartQuantity"
                    label="What is the minimum cart quantity to avail this?"
                    :options="[
                        { id: '1', label: 'None', value: 'None'},
                        { id: '2', label: 'Min Order Count', value: 'Min Order Count'},
                    ]"
                    name="cart_quantity"
                />
                <TextInput 
                    v-if="minimumCartQuantity === 'Min Order Count'"
                    id="min_quantity"
                    name="min_quantity"
                    placeholder="Max Order Count"
                />
            </div>
            <div class="col-span-12">
                <radio-group
                    v-model="minimumCartValue"
                    label="What is the minimum cart value to avail this?"
                    :options="[
                        { id: '1', label: 'None', value: 'None'},
                        { id: '2', label: 'Min Order Value', value: 'Min Order Value'},
                    ]"
                    name="cart_value"
                />
                <TextInput 
                    v-if="minimumCartValue === 'Min Order Value'"
                    id="max_usage"
                    name="max_usage"
                    placeholder="Min Order Value"
                />
            </div> -->
            <div class="col-span-12">
                <radio-group
                    label="Requirement Type"
                    :options="requirementOptions"
                    name="requirement_type"
                    keyID="requirement_type"
                    v-model="form.requirement_type"
                    :error="errors.requirement_type ? errors.requirement_type[0] : ''"
                />
                <TextInput 
                    :id="form.requirement_type === RequirementType.AMOUNT ? 'amount' : 'quantity'"
                    :name="form.requirement_type === RequirementType.AMOUNT ? 'amount' : 'quantity'"
                    :placeholder="form.requirement_type === RequirementType.AMOUNT ? 'Amount' : 'Quantity'"
                    :addOnRight="form.requirement_type === RequirementType.AMOUNT ? true : false"
                    :addOnText="form.requirement_type === RequirementType.AMOUNT ? 'PHP' : ''"
                    v-model="form.requirement_value"
                    :error="errors.requirement_value ? errors.requirement_value[0] : ''"
                />
            </div>
            <div class="col-span-12">
                <radio-group
                    label="Discount Type"
                    :options="discountOptions"
                    name="discount_type"
                    keyID="discount_type"
                    v-model="form.discount_type"
                    :error="errors.discount_type ? errors.discount_type[0] : ''"
                />
                <TextInput 
                    :id="form.discount_type === DiscountType.PERCENTAGE ? 'percent' : 'fixed'"
                    :name="form.discount_type === DiscountType.PERCENTAGE ? 'percent' : 'fixed'"
                    :placeholder="form.discount_type === DiscountType.PERCENTAGE ? 'Percent' : 'Fixed'"
                    :addOnRight="form.discount_type === DiscountType.PERCENTAGE ? true : false"
                    :addOnText="form.discount_type === DiscountType.PERCENTAGE ? '%' : 'PHP'"
                    v-model="form.discount_value"
                    :error="errors.discount_value ? errors.discount_value[0] : ''"
                />
            </div>
            <div class="col-span-12">
                <radio-group
                    label="Validity Range"
                    :options="validityRangeOptions"
                    name="validity_range"
                    keyID="validity_range"
                    v-model="form.validity_range_type"
                    :error="errors.validity_range_type ? errors.validity_range_type[0] : ''"
                />
                <div v-if="form.validity_range_type === ValidityRangeType.LIMITED" class="grid grid-cols-2 gap-6">
                    <DatePicker
                        id="startDate"
                        name="startDate"
                        placeholder="Start Date"
                        label="Start Date"
                        :minDate="minDate"
                        v-model="form.start_at"
                        :error="errors.start_at ? errors.start_at[0] : ''"
                        :timePicker="false"
                        :enableTimePicker="false"
                    />
                    <DatePicker
                        id="endDate"
                        name="endDate"
                        placeholder="End Date"
                        label="End Date"
                        :minDate="minDate"
                        v-model="form.end_at"
                        :error="errors.end_at ? errors.end_at[0] : ''"
                        :timePicker="false"
                        :enableTimePicker="false"
                    />
                </div>
            </div>

            <div class="col-span-12">
                <TextInput 
                    label="Description"
                    id="description"
                    name="description"
                    placeholder="Description"
                    textarea
                    textAreaRows="4"
                    v-model="form.description"
                    :error="errors.description ? errors.description[0] : ''"
                />
            </div>
        </template>
        <template #actions>
            <slot />
        </template>
    </FormSection>

    <PageLoader v-if="loader" />

    <ErrorModal
        width="w-[548px]"
        title="Error"
        action-text="Close"
        cancel-text="Go back"
        :show="showError"
        @close="showError = false"
        @confirm="showError = false"
        :errors="errors"
    >
        <template #content>
            {{ errorMsg }}
        </template>
    </ErrorModal>

    <SuccessModal
        :show="showSuccess"
        @cancel="showSuccess = false"
        @confirm="redirect()"
        action-text="Confirm"
        title="Voucher Created!"
        content="Voucher has been created successfully"
    />
</template>

<script setup lang="ts">
import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';

import { ref, onMounted, computed } from 'vue';

import { PackageType } from '@/enums/PackageType';
import { RiderType } from '@/enums/RiderType';
import { PatientType } from '@/enums/PatientType';
import { MaxUsageType } from '@/enums/MaxUsageType';
import { RequirementType } from '@/enums/RequirementType';
import { DiscountType } from '@/enums/DiscountType';
import { ValidityRangeType } from '@/enums/ValidityRangeType';

import { formattedRider } from '@/interfaces/CorporateBookingInterface'

const props = defineProps({
    form: {
        type: Object,
        required: true
    },
    packages: {
        type: Array,
        default: () => [],
    },
    services: {
        type: Array,
        default: () => [],
    },
    allergyTests: {
        type: Array,
        default: () => [],
    },
    patients: {
        type: Array,
        default: () => [],
    },
    packageOptions: {
        type: Array,
        default: () => [],
    },
    riderOptions: {
        type: Array,
        default: () => [],
    },
    patientOptions: {
        type: Array,
        default: () => [],
    },
    maxUsageOptions: {
        type: Array,
        default: () => [],
    },
    requirementOptions: {
        type: Array,
        default: () => [],
    },
    discountOptions: {
        type: Array,
        default: () => [],
    },
    validityRangeOptions: {
        type: Array,
        default: () => []
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const form = ref(props.form)

const minDate = new Date;

const riderFormattedOptions = computed(() => {
    const result = [];
    const riderGroups = props.services.concat(props.allergyTests);
    riderGroups.forEach((riderGroup: any) => {
        riderGroup.items.forEach((unformattedRider: any) => {
            const formattedRider: formattedRider = {
                id   : null,
                label: null,
                value: null,
                disabledDates: null,
                name: null,
            };
    
            formattedRider.id    = unformattedRider.item_id;
            formattedRider.value = unformattedRider.item_id;
            formattedRider.label = unformattedRider.item_name;
            formattedRider.disabledDates = unformattedRider.disabledDates;
            formattedRider.name = unformattedRider.item_name;

            result.push(formattedRider);
        });
    });

    return result;
})

onMounted(async() => {
    // ...
})
</script>